export default __webpack_public_path__ + "img/autocomplete-icons.5e674209e3f99a43da37eeba15d6e1d8.png";